"use strict";
exports.secondsInYear = exports.secondsInWeek = exports.secondsInQuarter = exports.secondsInMonth = exports.secondsInMinute = exports.secondsInHour = exports.secondsInDay = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInYear = exports.minutesInMonth = exports.minutesInHour = exports.minutesInDay = exports.minTime = exports.millisecondsInWeek = exports.millisecondsInSecond = exports.millisecondsInMinute = exports.millisecondsInHour = exports.millisecondsInDay = exports.maxTime = exports.daysInYear = exports.daysInWeek = void 0;
const daysInWeek = exports.daysInWeek = 7;
const daysInYear = exports.daysInYear = 365.2425;
const maxTime = exports.maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1e3;
const minTime = exports.minTime = -maxTime;
const millisecondsInWeek = exports.millisecondsInWeek = 6048e5;
const millisecondsInDay = exports.millisecondsInDay = 864e5;
const millisecondsInMinute = exports.millisecondsInMinute = 6e4;
const millisecondsInHour = exports.millisecondsInHour = 36e5;
const millisecondsInSecond = exports.millisecondsInSecond = 1e3;
const minutesInYear = exports.minutesInYear = 525600;
const minutesInMonth = exports.minutesInMonth = 43200;
const minutesInDay = exports.minutesInDay = 1440;
const minutesInHour = exports.minutesInHour = 60;
const monthsInQuarter = exports.monthsInQuarter = 3;
const monthsInYear = exports.monthsInYear = 12;
const quartersInYear = exports.quartersInYear = 4;
const secondsInHour = exports.secondsInHour = 3600;
const secondsInMinute = exports.secondsInMinute = 60;
const secondsInDay = exports.secondsInDay = secondsInHour * 24;
const secondsInWeek = exports.secondsInWeek = secondsInDay * 7;
const secondsInYear = exports.secondsInYear = secondsInDay * daysInYear;
const secondsInMonth = exports.secondsInMonth = secondsInYear / 12;
const secondsInQuarter = exports.secondsInQuarter = secondsInMonth * 3;
